import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import Modal from "react-bootstrap/Modal";
import TablePagination from "@mui/material/TablePagination";
import ReactLoading from "react-loading";

import Swal from "sweetalert2";
import moment from "moment";
import $ from "jquery";

import "daterangepicker/daterangepicker.css";
import "daterangepicker";

import config from "../../config";
import { useNetworkState } from "react-use";

import Footer from "./Footer";
import Header from "./Header";

const Weight_discrepancies_list = () => {
  const navigate = useNavigate();
  const isOnline = useNetworkState();

  /* =========================================================
     USER DATA
  ========================================================= */

  const userDetail = localStorage.getItem("ship_rocket_user");

  let userData = {};

  if (userDetail) {
    try {
      userData = JSON.parse(userDetail);
    } catch (error) {
      console.error("Unable to parse user data", error);
    }
  }

  const customerId = userData?.customer_id || "";

  /* =========================================================
     STATES
  ========================================================= */

  const [state, setState] = useState({
    shipment_list: [],
    isLoading: true,
  });

  const [searchstate, setSearchState] = useState({
    search_shipment: "",
  });

  const [otherStates, setOtherState] = useState({
    dstatus: 4,
    page: 0,
    rowsPerPage: 20,
    total_count: 0,
  });

  const [date, setDate] = useState({
    from_date: moment().subtract(30, "days").format("YYYY-MM-DD"),

    to_date: moment().format("YYYY-MM-DD"),
  });

  const [dateRange, setDateRange] = useState({
    startDate: moment().subtract(30, "days").startOf("day"),
    endDate: moment().startOf("day"),
  });

  const [selected, setSelected] = useState({
    select_count: 0,
    select_order_id: [],
  });

  /* =========================================================
     DISPUTE MODAL
  ========================================================= */

  const [modals, setModals] = useState({
    show: false,
  });

  const [viewModal, setViewModal] = useState({
    show: false,
    sub: {},
  });

  const [shipments, setShipments] = useState({
    shipment_id: "",
  });

  const [disputeText, setDisputeText] = useState("");

  const [images, setImages] = useState([]);

  const [videos, setVideos] = useState([]);

  const [disablebutton, setDisableButton] = useState(false);

  /* =========================================================
     LOADER
  ========================================================= */

  const [isLoading, setIsLoading] = useState(true);

  /* =========================================================
     FETCH SYSTEM DATE PREFERENCE
  ========================================================= */

  useEffect(() => {
    const fetchSystemPreferences = async () => {
      try {
        const response = await axios.post(
          config.apiUrl + "/user/system_preferences_fetch",
          {},
          {
            headers: config.headers,
          }
        );

        const data = response?.data;

        if (data?.orderDateRange === "7 Days") {
          setDateRange({
            startDate: moment().subtract(7, "days").startOf("day"),
            endDate: moment().startOf("day"),
          });
        } else if (data?.orderDateRange === "30 Days") {
          setDateRange({
            startDate: moment().subtract(30, "days").startOf("day"),
            endDate: moment().startOf("day"),
          });
        } else if (data?.orderDateRange === "Today") {
          setDateRange({
            startDate: moment().startOf("day"),
            endDate: moment().startOf("day"),
          });
        } else {
          setDateRange({
            startDate: moment().subtract(30, "days").startOf("day"),
            endDate: moment().startOf("day"),
          });
        }
      } catch (error) {
        console.error("system_preferences_fetch error", error);

        setDateRange({
          startDate: moment().subtract(30, "days").startOf("day"),
          endDate: moment().startOf("day"),
        });
      }
    };

    fetchSystemPreferences();
  }, []);

  /* =========================================================
     DATE PICKER
  ========================================================= */

  useEffect(() => {
    const picker = $(".custom-daterange");

    if (!picker.length) {
      return;
    }

    picker.daterangepicker(
      {
        opens: "right",

        startDate: dateRange.startDate,

        endDate: dateRange.endDate,

        autoUpdateInput: true,

        locale: {
          format: "YYYY-MM-DD",
        },

        ranges: {
          Today: [moment(), moment()],

          Yesterday: [
            moment().subtract(1, "days"),
            moment().subtract(1, "days"),
          ],

          "Last 7 Days": [moment().subtract(6, "days"), moment()],

          "This Week": [moment().startOf("week"), moment().endOf("week")],

          "Last Week": [
            moment().subtract(1, "week").startOf("week"),

            moment().subtract(1, "week").endOf("week"),
          ],

          "This Month": [moment().startOf("month"), moment().endOf("month")],

          "Last Month": [
            moment().subtract(1, "month").startOf("month"),

            moment().subtract(1, "month").endOf("month"),
          ],

          "Last 3 Months": [
            moment().subtract(3, "months").startOf("month"),

            moment().endOf("month"),
          ],

          "This Year": [moment().startOf("year"), moment()],
        },
      },

      (start, end) => {
        picker.val(
          `${start.format("YYYY-MM-DD")} to ${end.format("YYYY-MM-DD")}`
        );

        setDate({
          from_date: start.format("YYYY-MM-DD"),
          to_date: end.format("YYYY-MM-DD"),
        });

        setOtherState((prev) => ({
          ...prev,
          page: 0,
        }));
      }
    );

    picker.val(
      `${dateRange.startDate.format(
        "YYYY-MM-DD"
      )} to ${dateRange.endDate.format("YYYY-MM-DD")}`
    );

    return () => {
      const instance = picker.data("daterangepicker");

      if (instance) {
        instance.remove();
      }
    };
  }, [dateRange]);

  /* =========================================================
     FETCH WEIGHT DISCREPANCIES
  ========================================================= */

  const shipment_list = useCallback(
    async (status = null, page = 0, onLoad = true) => {
      if (!isOnline?.online) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Network Connection Error",
        });

        return;
      }

      try {
        if (onLoad) {
          setIsLoading(true);

          setState((prev) => ({
            ...prev,
            isLoading: true,
          }));
        }

        const dataToSend = {
          customer_id: customerId,

          find: searchstate.search_shipment,

          status: status,

          limit: otherStates.rowsPerPage,

          indexValue: page,

          discrepencies_status: otherStates.dstatus,

          from_date: date.from_date,

          to_date: date.to_date,
        };

        const response = await axios.post(
          config.apiUrl + "/shipment/weight_discrepancies_list",

          dataToSend,

          {
            headers: config.headers,
          }
        );

        const responseData = response?.data || {};

        const shipmentList = Array.isArray(responseData.output)
          ? responseData.output
          : [];

        const totalCount = Number(responseData.count) || 0;

        setState({
          shipment_list: shipmentList,
          isLoading: false,
        });

        setOtherState((prev) => ({
          ...prev,

          total_count: totalCount,

          page: page,
        }));

        setIsLoading(false);

        // Clear selected items whenever fresh data loads
        setSelected({
          select_count: 0,
          select_order_id: [],
        });
      } catch (error) {
        console.error("weight_discrepancies_list error", error);

        setState({
          shipment_list: [],
          isLoading: false,
        });

        setIsLoading(false);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text:
            error?.response?.data?.message ||
            "Unable to fetch weight discrepancies.",
        });
      }
    },

    [
      isOnline?.online,
      customerId,
      searchstate.search_shipment,
      otherStates.rowsPerPage,
      otherStates.dstatus,
      date.from_date,
      date.to_date,
    ]
  );

  /* =========================================================
     INITIAL + FILTER API CALL
  ========================================================= */

  useEffect(() => {
    shipment_list(null, 0, true);
  }, [
    otherStates.dstatus,
    date.from_date,
    date.to_date,
    otherStates.rowsPerPage,
  ]);

  /* =========================================================
     SEARCH
  ========================================================= */

  const handlesearchShipment = (e) => {
    const value = e.target.value;

    setSearchState({
      search_shipment: value,
    });
  };

  const handleSearchClick = () => {
    setOtherState((prev) => ({
      ...prev,
      page: 0,
    }));

    shipment_list(null, 0, true);
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearchClick();
    }
  };

  /* =========================================================
     STATUS TAB
  ========================================================= */

  const statusChange = (status) => {
    setOtherState((prev) => ({
      ...prev,

      dstatus: status,

      page: 0,
    }));
  };

  /* =========================================================
     PAGINATION
  ========================================================= */

  const handlePageChange = (event, newPage) => {
    setOtherState((prev) => ({
      ...prev,

      page: newPage,
    }));

    shipment_list(null, newPage, true);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);

    setOtherState((prev) => ({
      ...prev,

      rowsPerPage: newRowsPerPage,

      page: 0,
    }));
  };

  /* =========================================================
     DATE SELECT
  ========================================================= */

  const dateselect = (start, end) => {
    setDate({
      from_date: moment(start).format("YYYY-MM-DD"),

      to_date: moment(end).format("YYYY-MM-DD"),
    });
  };

  /* =========================================================
     IMAGE UPLOAD
  ========================================================= */

  const handleImageUpload = (e) => {
    const uploadedImages = Array.from(e.target.files || []);

    if (!uploadedImages.length) {
      return;
    }

    if (uploadedImages.length + images.length > 3) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "You can only upload up to 3 images.",
      });

      e.target.value = "";

      return;
    }

    const totalSize = uploadedImages.reduce(
      (acc, image) => acc + image.size,
      0
    );

    if (totalSize > 10 * 1024 * 1024) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Total image size cannot exceed 10 MB.",
      });

      e.target.value = "";

      return;
    }

    setImages((prevImages) => [...prevImages, ...uploadedImages]);

    e.target.value = "";
  };

  /* =========================================================
     VIDEO UPLOAD
  ========================================================= */

  const handleVideoUpload = (e) => {
    const uploadedVideos = Array.from(e.target.files || []);

    if (!uploadedVideos.length) {
      return;
    }

    if (uploadedVideos.length + videos.length > 3) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "You can only upload up to 3 videos.",
      });

      e.target.value = "";

      return;
    }

    const totalSize = uploadedVideos.reduce(
      (acc, video) => acc + video.size,
      0
    );

    if (totalSize > 100 * 1024 * 1024) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Total video size cannot exceed 100 MB.",
      });

      e.target.value = "";

      return;
    }

    setVideos((prevVideos) => [...prevVideos, ...uploadedVideos]);

    e.target.value = "";
  };

  /* =========================================================
     REMOVE IMAGE
  ========================================================= */

  const removeImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  /* =========================================================
     REMOVE VIDEO
  ========================================================= */

  const removeVideo = (index) => {
    setVideos((prevVideos) => prevVideos.filter((_, i) => i !== index));
  };

  /* =========================================================
     OPEN RAISE DISPUTE MODAL
  ========================================================= */

  const handlemodals = (item) => {
    setShipments({
      shipment_id: item?.shipment_id || "",
    });

    setDisputeText("");

    setImages([]);

    setVideos([]);

    setModals({
      show: true,
    });
  };

  /* =========================================================
     BULK DISPUTE MODAL
  ========================================================= */

  const handlemodalsbulk = () => {
    if (selected.select_order_id.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No shipment selected",
        text: "Please select at least one shipment.",
      });

      return;
    }

    setShipments({
      shipment_id: "",
    });

    setDisputeText("");

    setImages([]);

    setVideos([]);

    setModals({
      show: true,
    });
  };

  /* =========================================================
     CLOSE RAISE DISPUTE MODAL
  ========================================================= */

  const handleclosemodals = () => {
    setModals({
      show: false,
    });

    setDisputeText("");

    setShipments({
      shipment_id: "",
    });

    setImages([]);

    setVideos([]);

    setDisableButton(false);
  };

  /* =========================================================
     OPEN VIEW / UPDATE MODAL
  ========================================================= */

  const handleViewDispute = (item) => {
    setViewModal({
      show: true,
      sub: item,
    });

    setDisputeText("");

    setImages([]);

    setVideos([]);
  };

  /* =========================================================
     CLOSE VIEW MODAL
  ========================================================= */

  const handlecloseviewmodals = () => {
    setViewModal({
      show: false,
      sub: {},
    });

    setDisputeText("");

    setImages([]);

    setVideos([]);

    setDisableButton(false);
  };

  /* =========================================================
     SUBMIT NEW DISPUTE
  ========================================================= */

  const handleSubmit = async () => {
    if (!disputeText.trim()) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter dispute issue.",
      });

      return;
    }

    setDisableButton(true);

    try {
      const formData = new FormData();

      formData.append("disputeText", disputeText);

      formData.append("customerid", customerId);

      const shipmentId =
        shipments.shipment_id || selected.select_order_id.join(",");

      formData.append("shipmentid", shipmentId);

      images.forEach((image, index) => {
        formData.append(`image${index}`, image);
      });

      videos.forEach((video, index) => {
        formData.append(`video${index}`, video);
      });

      const response = await axios.post(
        config.apiUrl + "/user/submit_dispute",

        formData,

        {
          headers: {
            ...config.headers,

            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response?.status === 200 && response?.data?.status !== false) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.data?.message || "Dispute submitted successfully!",
        });

        handleclosemodals();

        shipment_list(null, 0, true);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response?.data?.message || "Failed to submit dispute.",
        });

        setDisableButton(false);
      }
    } catch (error) {
      console.error("submit_dispute error", error);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          error?.response?.data?.message ||
          "An error occurred. Please try again.",
      });

      setDisableButton(false);
    }
  };

  /* =========================================================
     UPDATE DISPUTE
  ========================================================= */

  const handleUpdateSubmit = async () => {
    if (!disputeText.trim()) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter dispute issue.",
      });

      return;
    }

    setDisableButton(true);

    try {
      const formData = new FormData();

      formData.append("disputeText", disputeText);

      formData.append("customerid", customerId);

      formData.append("shipmentid", viewModal?.sub?.shipment_id || "");

      images.forEach((image, index) => {
        formData.append(`image${index}`, image);
      });

      videos.forEach((video, index) => {
        formData.append(`video${index}`, video);
      });

      const response = await axios.post(
        config.apiUrl + "/user/update_submit_dispute",

        formData,

        {
          headers: {
            ...config.headers,

            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response?.status === 200 && response?.data?.status !== false) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.data?.message || "Dispute updated successfully!",
        });

        handlecloseviewmodals();

        shipment_list(null, 0, true);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response?.data?.message || "Failed to update dispute.",
        });

        setDisableButton(false);
      }
    } catch (error) {
      console.error("update_submit_dispute error", error);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          error?.response?.data?.message ||
          "An error occurred. Please try again.",
      });

      setDisableButton(false);
    }
  };

  /* =========================================================
     SELECT ALL
  ========================================================= */

  const handleSelectAll = (event) => {
    const checked = event.target.checked;

    if (!checked) {
      setSelected({
        select_count: 0,
        select_order_id: [],
      });

      return;
    }

    const selectedIds = state.shipment_list
      .filter((order) => Number(order.discrepencies_dispute_status) === 0)
      .map((order) => `${order.shipment_id}`);

    setSelected({
      select_count: selectedIds.length,

      select_order_id: selectedIds,
    });
  };

  /* =========================================================
     SELECT INDIVIDUAL
  ========================================================= */

  const handleChangeSelected = (e, sub) => {
    const shipmentId = `${sub.shipment_id}`;

    if (Number(sub.discrepencies_dispute_status) !== 0) {
      return;
    }

    setSelected((prevSelected) => {
      const alreadySelected = prevSelected.select_order_id.includes(shipmentId);

      if (alreadySelected) {
        return {
          select_count: prevSelected.select_count - 1,

          select_order_id: prevSelected.select_order_id.filter(
            (id) => id !== shipmentId
          ),
        };
      }

      return {
        select_count: prevSelected.select_count + 1,

        select_order_id: [...prevSelected.select_order_id, shipmentId],
      };
    });
  };

  /* =========================================================
     STATUS HELPERS
  ========================================================= */

  const getStatusBadge = (status) => {
    switch (Number(status)) {
      case 0:
        return <span className="badge bg-primary">Action Required</span>;

      case 1:
        return <span className="badge bg-warning">Dispute Raised</span>;

      case 2:
        return <span className="badge bg-success">Accepted</span>;

      case 3:
        return <span className="badge bg-danger">Closed</span>;

      default:
        return <span className="badge bg-secondary">Unknown</span>;
    }
  };

  /* =========================================================
     DIFFERENCE
  ========================================================= */

  const getDifference = (item) => {
    const originalAmount = Number(item?.total_amount) || 0;

    const discrepancyAmount =
      item?.discrepencies_amount !== undefined &&
      item?.discrepencies_amount !== null &&
      item?.discrepencies_amount !== ""
        ? Number(item.discrepencies_amount)
        : originalAmount;

    return originalAmount - discrepancyAmount;
  };

  const renderDifference = (item) => {
    const difference = getDifference(item);

    return (
      <span
        className={
          difference > 0 ? "text-danger" : difference < 0 ? "text-success" : ""
        }
      >
        {difference > 0
          ? `+₹${difference.toFixed(2)}`
          : difference < 0
          ? `₹${difference.toFixed(2)}`
          : "₹0.00"}
      </span>
    );
  };

  /* =========================================================
     WEIGHT DETAILS
  ========================================================= */

  const getBookingWeight = (item) => {
    const weight = item?.total_weight ?? 0;

    const length = item?.length ?? "";

    const width = item?.width ?? "";

    const height = item?.height ?? "";

    return (
      <>
        <div>
          <small>{weight} KG</small>
        </div>

        {(length || width || height) && (
          <div>
            <small>
              {length} x {width} x {height} cm
            </small>
          </div>
        )}
      </>
    );
  };

  const getUpdatedWeight = (item) => {
    const weight = item?.discrepencies_weight || item?.total_weight || 0;

    const length = item?.discrepencies_length || item?.length || "";

    const width = item?.discrepencies_width || item?.width || "";

    const height = item?.discrepencies_height || item?.height || "";

    return (
      <>
        <div>
          <small>{weight} KG</small>
        </div>

        {(length || width || height) && (
          <div>
            <small>
              {length} x {width} x {height} cm
            </small>
          </div>
        )}
      </>
    );
  };

  /* =========================================================
     ATTACHMENT RENDER
  ========================================================= */

  const isImage = (file) => {
    if (!file) {
      return false;
    }

    const lowerFile = file.toLowerCase();

    return (
      lowerFile.endsWith(".jpg") ||
      lowerFile.endsWith(".jpeg") ||
      lowerFile.endsWith(".png") ||
      lowerFile.endsWith(".webp") ||
      lowerFile.endsWith(".gif")
    );
  };

  const renderAttachments = (files) => {
    if (!Array.isArray(files) || files.length === 0) {
      return null;
    }

    return (
      <div className="d-flex flex-wrap">
        {files.map((file, index) => (
          <div key={index} className="m-2">
            {isImage(file) ? (
              <img
                src={file}
                alt={`attachment-${index}`}
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                  borderRadius: "6px",
                }}
              />
            ) : (
              <video
                width="100"
                height="100"
                controls
                style={{
                  objectFit: "cover",
                  borderRadius: "6px",
                }}
              >
                <source src={file} />
                Your browser does not support the video tag.
              </video>
            )}
          </div>
        ))}
      </div>
    );
  };

  /* =========================================================
     DISPUTE TEXT ARRAY
  ========================================================= */

  const renderDisputeIssues = (issues) => {
    if (!Array.isArray(issues) || issues.length === 0) {
      return null;
    }

    return issues.map((item, index) => (
      <textarea
        key={index}
        className="form-control mb-2"
        rows="3"
        value={item}
        disabled
        readOnly
      />
    ));
  };

  /* =========================================================
     SELECT ALL CHECK
  ========================================================= */

  const selectableRows = state.shipment_list.filter(
    (item) => Number(item.discrepencies_dispute_status) === 0
  );

  const allSelected =
    selectableRows.length > 0 &&
    selectableRows.every((item) =>
      selected.select_order_id.includes(`${item.shipment_id}`)
    );

  /* =========================================================
     RENDER
  ========================================================= */

  return (
    <div>
      <Header>
        <div className="content">
          {/* =====================================================
                    MOBILE HEADER
                ===================================================== */}

          <div className="mob_nav">
            <div className="row">
              <div className="col">
                <div className="d-flex justify-content-start">
                  <a
                    href="#"
                    className="back_btn"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(-1);
                    }}
                  >
                    <i className="bi bi-arrow-left"></i>
                  </a>

                  <h2>Weight Discrepancies</h2>
                </div>
              </div>
            </div>
          </div>

          {/* =====================================================
                    DESKTOP HEADER
                ===================================================== */}

          <div className="row justify-content-between desk_nav">
            <div className="col-12 col-md-4">
              <div className="d-flex">
                <a
                  href="#"
                  className="back_btn"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(-1);
                  }}
                >
                  <i className="bi bi-arrow-90deg-left"></i>
                </a>

                <h2>Weight Discrepancies</h2>
              </div>
            </div>

            <div className="col-12 col-md-4 mb-3"></div>
          </div>

          {/* =====================================================
                    RAISE DISPUTE MODAL
                ===================================================== */}

          <Modal show={modals.show} onHide={handleclosemodals} centered>
            <Modal.Header closeButton>
              <Modal.Title>Raise Dispute</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="text-center p-3">
                <textarea
                  className="form-control mb-4"
                  placeholder="Describe your issue..."
                  value={disputeText}
                  onChange={(e) => setDisputeText(e.target.value)}
                  rows="4"
                />

                {/* IMAGE */}
                <div className="mb-4 text-start">
                  <label className="form-label">Upload Images (up to 3)</label>

                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleImageUpload}
                    className="form-control"
                  />

                  <small className="text-muted">
                    Maximum 3 images / 10 MB total
                  </small>
                </div>

                <div className="d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div key={index} className="position-relative m-2">
                      <img
                        src={URL.createObjectURL(image)}
                        alt={`uploaded-${index}`}
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                          borderRadius: "5px",
                        }}
                      />

                      <button
                        type="button"
                        className="btn btn-danger btn-sm position-absolute top-0 end-0"
                        onClick={() => removeImage(index)}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>

                {/* VIDEO */}
                <div className="mb-4 text-start">
                  <label className="form-label">Upload Videos (up to 3)</label>

                  <input
                    type="file"
                    accept="video/*"
                    multiple
                    onChange={handleVideoUpload}
                    className="form-control"
                  />

                  <small className="text-muted">
                    Maximum 3 videos / 100 MB total
                  </small>
                </div>

                <div className="d-flex flex-wrap">
                  {videos.map((video, index) => (
                    <div key={index} className="position-relative m-2">
                      <video
                        src={URL.createObjectURL(video)}
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                        }}
                        controls
                      />

                      <button
                        type="button"
                        className="btn btn-danger btn-sm position-absolute top-0 end-0"
                        onClick={() => removeVideo(index)}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <button className="btn btn-secondary" onClick={handleclosemodals}>
                Close
              </button>

              <button
                className="btn btn-primary"
                disabled={disablebutton}
                onClick={handleSubmit}
              >
                {disablebutton ? "Submitting..." : "Submit"}
              </button>
            </Modal.Footer>
          </Modal>

          {/* =====================================================
                    VIEW / UPDATE DISPUTE MODAL
                ===================================================== */}

          <Modal
            show={viewModal.show}
            onHide={handlecloseviewmodals}
            centered
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title>View and Update Dispute</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="modal-body">
                {/* CUSTOMER DISPUTE */}
                {viewModal?.sub?.discrepencies_dispute_issue?.length > 0 && (
                  <div className="mb-4">
                    <label className="fw-bold">Dispute Text:</label>

                    {renderDisputeIssues(
                      viewModal.sub.discrepencies_dispute_issue
                    )}
                  </div>
                )}

                {/* CUSTOMER ATTACHMENTS */}
                {viewModal?.sub?.discrepencies_dispute_images?.length > 0 && (
                  <div className="mb-4">
                    <label className="fw-bold">
                      Attached Images and Videos:
                    </label>

                    {renderAttachments(
                      viewModal.sub.discrepencies_dispute_images
                    )}
                  </div>
                )}

                {/* ADMIN DISPUTE */}
                {viewModal?.sub?.admin_discrepencies_dispute_issue?.length >
                  0 && (
                  <div className="mb-4">
                    <label className="fw-bold">Admin Dispute Text:</label>

                    {renderDisputeIssues(
                      viewModal.sub.admin_discrepencies_dispute_issue
                    )}
                  </div>
                )}

                {/* ADMIN ATTACHMENTS */}
                {viewModal?.sub?.admin_discrepencies_dispute_images?.length >
                  0 && (
                  <div className="mb-4">
                    <label className="fw-bold">
                      Admin Attached Images and Videos:
                    </label>

                    {renderAttachments(
                      viewModal.sub.admin_discrepencies_dispute_images
                    )}
                  </div>
                )}

                {/* UPDATE TEXT */}
                <textarea
                  className="form-control mb-4"
                  placeholder="Describe your issue..."
                  value={disputeText}
                  onChange={(e) => setDisputeText(e.target.value)}
                  rows="4"
                />

                {/* UPDATE IMAGES */}
                <div className="mb-4">
                  <label className="form-label">Upload Images (up to 3)</label>

                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleImageUpload}
                    className="form-control"
                  />
                </div>

                <div className="d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div key={index} className="position-relative m-2">
                      <img
                        src={URL.createObjectURL(image)}
                        alt={`uploaded-${index}`}
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                        }}
                      />

                      <button
                        type="button"
                        className="btn btn-danger btn-sm position-absolute top-0 end-0"
                        onClick={() => removeImage(index)}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>

                {/* UPDATE VIDEOS */}
                <div className="mb-4">
                  <label className="form-label">Upload Videos (up to 3)</label>

                  <input
                    type="file"
                    accept="video/*"
                    multiple
                    onChange={handleVideoUpload}
                    className="form-control"
                  />
                </div>

                <div className="d-flex flex-wrap">
                  {videos.map((video, index) => (
                    <div key={index} className="position-relative m-2">
                      <video
                        src={URL.createObjectURL(video)}
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                        }}
                        controls
                      />

                      <button
                        type="button"
                        className="btn btn-danger btn-sm position-absolute top-0 end-0"
                        onClick={() => removeVideo(index)}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <button
                className="btn btn-secondary"
                onClick={handlecloseviewmodals}
              >
                Close
              </button>

              <button
                className="btn btn-primary"
                disabled={disablebutton}
                onClick={handleUpdateSubmit}
              >
                {disablebutton ? "Updating..." : "Update Dispute"}
              </button>
            </Modal.Footer>
          </Modal>

          {/* =====================================================
                    FILTER CARD
                ===================================================== */}

          <div className="card mb-3">
            <div className="card-body">
              <div className="row justify-content-between">
                <div className="col-12 col-md-6 mb-1">
                  <div className="row g-1">
                    {/* DATE */}
                    <div className="col-12 col-md-6">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control custom-daterange"
                          readOnly
                        />

                        <span
                          className="input-group-text"
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            $(".custom-daterange").trigger("click")
                          }
                        >
                          <i className="bi bi-calendar2-range"></i>
                        </span>
                      </div>
                    </div>

                    {/* SEARCH */}
                    <div className="col-12 col-md-6">
                      <div className="search-box">
                        <div
                          className="search-icon"
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={handleSearchClick}
                        >
                          <i className="bi bi-search"></i>
                        </div>

                        <input
                          type="text"
                          className="search-input"
                          name="search_shipment"
                          placeholder="Enter AWB Number"
                          value={searchstate.search_shipment}
                          onChange={handlesearchShipment}
                          onKeyDown={handleSearchKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* BULK ACTION */}
                <div className="col-12 col-md-6 mb-1">
                  <div className="row justify-content-between">
                    <div className="col-6 col-md-6">
                      <div className="dropdown">
                        <button
                          type="button"
                          className="btn btn-outline-secondary dropdown-toggle"
                          data-bs-toggle="dropdown"
                        >
                          Bulk Actions
                        </button>

                        <ul className="dropdown-menu">
                          {selected.select_count > 0 ? (
                            <li>
                              <button
                                type="button"
                                className="dropdown-item"
                                onClick={handlemodalsbulk}
                              >
                                Raise Dispute
                              </button>
                            </li>
                          ) : (
                            <li>
                              <span className="dropdown-item text-muted">
                                Select shipment first
                              </span>
                            </li>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* =====================================================
                    MAIN CARD
                ===================================================== */}

          <div className="card mb-3 weight_discepancies_list">
            <div className="card-body">
              <div className="custom-tabs-container">
                {/* =================================================
                          TABS
                      ================================================= */}

                <ul className="nav nav-tabs" id="customTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      type="button"
                      className={
                        "nav-link" +
                        (otherStates.dstatus === 4 ? " active" : "")
                      }
                      onClick={() => statusChange(4)}
                    >
                      All
                    </button>
                  </li>

                  <li className="nav-item" role="presentation">
                    <button
                      type="button"
                      className={
                        "nav-link" +
                        (otherStates.dstatus === 0 ? " active" : "")
                      }
                      onClick={() => statusChange(0)}
                    >
                      Action Required
                    </button>
                  </li>

                  <li className="nav-item" role="presentation">
                    <button
                      type="button"
                      className={
                        "nav-link" +
                        (otherStates.dstatus === 1 ? " active" : "")
                      }
                      onClick={() => statusChange(1)}
                    >
                      Dispute Raised
                    </button>
                  </li>

                  <li className="nav-item" role="presentation">
                    <button
                      type="button"
                      className={
                        "nav-link" +
                        (otherStates.dstatus === 2 ? " active" : "")
                      }
                      onClick={() => statusChange(2)}
                    >
                      Accepted
                    </button>
                  </li>

                  <li className="nav-item" role="presentation">
                    <button
                      type="button"
                      className={
                        "nav-link" +
                        (otherStates.dstatus === 3 ? " active" : "")
                      }
                      onClick={() => statusChange(3)}
                    >
                      Closed
                    </button>
                  </li>
                </ul>

                {/* =================================================
                          CONTENT
                      ================================================= */}

                <div className="tab-content">
                  <div className="tab-pane fade show active">
                    {/* =================================================
                              DESKTOP TABLE
                          ================================================= */}

                    <div className="card data_table mb-3 mb_display_none">
                      <div className="card-body">
                        <div className="table-responsive">
                          <div className="shipm_tablew rounded-3">
                            <table className="table align-top table-striped table-hover m-0 table-xl">
                              <thead>
                                <tr>
                                  <th>
                                    <input
                                      className="form-check-input form-check-input-lg"
                                      type="checkbox"
                                      checked={allSelected}
                                      onChange={handleSelectAll}
                                      disabled={selectableRows.length === 0}
                                    />
                                  </th>

                                  <th>Weight Applied Date</th>

                                  <th>Order Number</th>

                                  <th>AWB Number</th>

                                  <th>Entered Weight</th>

                                  <th>Weight Charges</th>

                                  <th>Applied Weight</th>

                                  <th>Final Weight Charges</th>

                                  <th>Difference</th>

                                  <th>Action</th>

                                  <th>Status</th>
                                </tr>
                              </thead>

                              <tbody>
                                {/* LOADING */}
                                {isLoading ? (
                                  <tr>
                                    <td
                                      colSpan="11"
                                      className="text-center py-5"
                                    >
                                      <div className="d-flex justify-content-center">
                                        <ReactLoading
                                          type="spin"
                                          color="#333"
                                          height={40}
                                          width={40}
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                ) : state.shipment_list.length === 0 ? (
                                  <tr>
                                    <td
                                      colSpan="11"
                                      className="text-center py-5"
                                    >
                                      No weight discrepancies found.
                                    </td>
                                  </tr>
                                ) : (
                                  state.shipment_list.map((sub, index) => {
                                    const originalAmount =
                                      Number(sub?.total_amount) || 0;

                                    const finalAmount =
                                      sub?.discrepencies_amount !== undefined &&
                                      sub?.discrepencies_amount !== null &&
                                      sub?.discrepencies_amount !== ""
                                        ? Number(sub.discrepencies_amount)
                                        : originalAmount;

                                    return (
                                      <tr key={sub?.shipment_id || index}>
                                        {/* CHECKBOX */}
                                        <td>
                                          <input
                                            className="form-check-input form-check-input-lg"
                                            type="checkbox"
                                            checked={selected.select_order_id.includes(
                                              `${sub.shipment_id}`
                                            )}
                                            disabled={
                                              Number(
                                                sub.discrepencies_dispute_status
                                              ) !== 0
                                            }
                                            onChange={(e) =>
                                              handleChangeSelected(e, sub)
                                            }
                                          />
                                        </td>

                                        {/* DATE */}
                                        <td>
                                          <small>
                                            {sub?.discrepencies_date
                                              ? moment(
                                                  new Date(
                                                    Number(
                                                      sub.discrepencies_date
                                                    ) * 1000
                                                  )
                                                ).format(
                                                  "MMM DD YYYY - hh:mm:ss a"
                                                )
                                              : "-"}
                                          </small>
                                        </td>

                                        {/* ORDER */}
                                        <td>
                                          <h6>
                                            <a
                                              href="#"
                                              className="text-primary"
                                              onClick={(e) =>
                                                e.preventDefault()
                                              }
                                            >
                                              {sub?.order_number || "-"}
                                            </a>
                                          </h6>
                                        </td>

                                        {/* AWB */}
                                        <td>
                                          <h6>
                                            <a
                                              href={`/tracking/${sub?.carrier_tracking_number}`}
                                              className="text-primary"
                                            >
                                              {sub?.carrier_tracking_number ||
                                                "-"}
                                            </a>
                                          </h6>

                                          {sub?.carrier_name && (
                                            <small>{sub.carrier_name}</small>
                                          )}
                                        </td>

                                        {/* BOOKING WEIGHT */}
                                        <td>{getBookingWeight(sub)}</td>

                                        {/* ORIGINAL CHARGE */}
                                        <td>
                                          <span>
                                            ₹ {originalAmount.toFixed(2)}
                                          </span>
                                        </td>

                                        {/* UPDATED WEIGHT */}
                                        <td>{getUpdatedWeight(sub)}</td>

                                        {/* FINAL CHARGE */}
                                        <td>
                                          <span>
                                            ₹ {finalAmount.toFixed(2)}
                                          </span>
                                        </td>

                                        {/* DIFFERENCE */}
                                        <td>{renderDifference(sub)}</td>

                                        {/* ACTION */}
                                        <td>
                                          {Number(
                                            sub.discrepencies_dispute_status
                                          ) === 0 ? (
                                            <button
                                              type="button"
                                              onClick={() => handlemodals(sub)}
                                              className="btn btn-outline-secondary btn-sm"
                                            >
                                              Raise Dispute
                                            </button>
                                          ) : (
                                            <button
                                              type="button"
                                              onClick={() =>
                                                handleViewDispute(sub)
                                              }
                                              className="btn btn-outline-primary btn-sm"
                                            >
                                              View
                                            </button>
                                          )}
                                        </td>

                                        {/* STATUS */}
                                        <td>
                                          {getStatusBadge(
                                            sub.discrepencies_dispute_status
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* =================================================
                              MOBILE VIEW
                          ================================================= */}

                    <section className="desk_display_none">
                      {isLoading ? (
                        <div className="card mb-3">
                          <div className="card-body text-center py-5">
                            <ReactLoading
                              type="spin"
                              color="#333"
                              height={40}
                              width={40}
                            />
                          </div>
                        </div>
                      ) : state.shipment_list.length === 0 ? (
                        <div className="card mb-3">
                          <div className="card-body text-center py-5">
                            No weight discrepancies found.
                          </div>
                        </div>
                      ) : (
                        state.shipment_list.map((sub, index) => {
                          const originalAmount = Number(sub?.total_amount) || 0;

                          const finalAmount =
                            sub?.discrepencies_amount !== undefined &&
                            sub?.discrepencies_amount !== null &&
                            sub?.discrepencies_amount !== ""
                              ? Number(sub.discrepencies_amount)
                              : originalAmount;

                          return (
                            <div
                              className="card mb-3"
                              key={sub?.shipment_id || index}
                            >
                              <div className="card-body">
                                <div className="row">
                                  {/* AWB */}
                                  <div className="col-6 mb-2">
                                    <h5>
                                      <a
                                        href={`/tracking/${sub?.carrier_tracking_number}`}
                                      >
                                        {sub?.carrier_tracking_number || "-"}
                                      </a>
                                    </h5>

                                    <small>AWB Number</small>
                                  </div>

                                  {/* STATUS */}
                                  <div className="col-6 mb-2 text-end">
                                    {getStatusBadge(
                                      sub.discrepencies_dispute_status
                                    )}
                                  </div>

                                  {/* ORDER */}
                                  <div className="col-12 mb-2">
                                    <h5>Order Number</h5>

                                    <a href="#">{sub?.order_number || "-"}</a>
                                  </div>

                                  {/* DATE */}
                                  <div className="col-6 mb-2">
                                    <h5>Weight Applied Date</h5>

                                    {sub?.discrepencies_date
                                      ? moment(
                                          new Date(
                                            Number(sub.discrepencies_date) *
                                              1000
                                          )
                                        ).format("MMM DD YYYY - hh:mm:ss a")
                                      : "-"}
                                  </div>

                                  {/* BOOKING WEIGHT */}
                                  <div className="col-6 mb-2">
                                    <h5>Entered Weight</h5>

                                    {getBookingWeight(sub)}
                                  </div>

                                  {/* CHARGED */}
                                  <div className="col-6 mb-2">
                                    <h5>Weight Charges</h5>₹{" "}
                                    {originalAmount.toFixed(2)}
                                  </div>

                                  {/* UPDATED */}
                                  <div className="col-6 mb-2">
                                    <h5>Applied Weight</h5>

                                    {getUpdatedWeight(sub)}
                                  </div>

                                  {/* FINAL */}
                                  <div className="col-6 mb-2">
                                    <h5>Final Weight Charges</h5>₹{" "}
                                    {finalAmount.toFixed(2)}
                                  </div>

                                  {/* DIFFERENCE */}
                                  <div className="col-6 mb-2">
                                    <h5>Difference</h5>

                                    {renderDifference(sub)}
                                  </div>

                                  {/* ACTION */}
                                  <div className="col-12">
                                    <div className="d-grid">
                                      {Number(
                                        sub.discrepencies_dispute_status
                                      ) === 0 ? (
                                        <button
                                          type="button"
                                          onClick={() => handlemodals(sub)}
                                          className="btn btn-danger btn-block"
                                        >
                                          Raise Dispute
                                        </button>
                                      ) : (
                                        <button
                                          type="button"
                                          onClick={() => handleViewDispute(sub)}
                                          className="btn btn-primary btn-block"
                                        >
                                          View
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      )}
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* =====================================================
                    PAGINATION
                ===================================================== */}

          <TablePagination
            component="div"
            rowsPerPageOptions={[20, 25, 30, 35, 40, 45, 50]}
            count={otherStates.total_count}
            page={otherStates.page}
            onPageChange={handlePageChange}
            rowsPerPage={otherStates.rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </Header>
      <Footer />
    </div>
  );
};

export default Weight_discrepancies_list;
